import { getFileExtension } from "./getFileExtension";

/**
 * * Проверка является ли файл изображением
 * @param file Файл
 * @returns
 */
export const checkIsImageFile = (file: File) => {
  const fileExtension = getFileExtension(file.name);
  return ["gif", "jpg", "jpeg", "png", "svg", "webp"].includes(fileExtension);
};
